import React from 'react'
import { makeStyles } from '@material-ui/core'
import BigLeaf from '../../assets/images/bigLeaf.png'

const useStyles = makeStyles((theme) => ({
  imageStyle: {
    width: '116px',
    height: '61px',
    [theme.breakpoints.up('md')]: {
      width: '195.8px',
      height: '112.8px'
    },
    [theme.breakpoints.up('lg')]: {
      width: '194.1px',
      height: '127.3px'
    }
  }
}))

export default () => {
  const classes = useStyles()
  return <img src={BigLeaf} alt="leaf" className={classes.imageStyle} />
}

